var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isLocked
    ? _c(
        "div",
        { attrs: { id: "lock-screen" } },
        [
          _c("img", {
            staticClass: "logo",
            attrs: { src: require("@/assets/img/logo_r.png"), alt: "WF Logo" },
          }),
          _vm.enteredTag && _vm.pinCodeRequired
            ? [
                _c("div", { staticClass: "status-msg" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("pin-code-is-required")) + " "),
                ]),
                _c(
                  "div",
                  { staticClass: "input-container" },
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.cancel"),
                            expression: "$ct('common.cancel')",
                          },
                        ],
                        staticClass: "cancel-button danger",
                        attrs: { disabled: _vm.isSending },
                        on: {
                          click: function ($event) {
                            return _vm.cancelPinCode()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "ban" } })],
                      1
                    ),
                    _c("app-nfc-pin-code-input", {
                      staticClass: "pin-code-field",
                      attrs: {
                        disabled: _vm.isSending,
                        placeholder: _vm.$ct("pin-code"),
                        autofocus: "",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.submitPinCode()
                        },
                      },
                      model: {
                        value: _vm.pinCode,
                        callback: function ($$v) {
                          _vm.pinCode = $$v
                        },
                        expression: "pinCode",
                      },
                    }),
                    _c(
                      "w-button",
                      {
                        staticClass: "submit-button",
                        attrs: { disabled: _vm.isSending },
                        on: {
                          click: function ($event) {
                            return _vm.submitPinCode()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "unlock-alt" } })],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c("div", { staticClass: "status-msg" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("winfakt-is-locked")) + " "),
                  _c("div", { staticClass: "explenation" }, [
                    _vm._v(_vm._s(_vm.$ct(_vm.instructionMessage))),
                  ]),
                  _c("div", { staticClass: "explenation" }, [
                    _vm._v(
                      _vm._s(_vm.$ct("logged-in-as", { user: _vm.userName }))
                    ),
                  ]),
                ]),
                _vm.passwordFieldVisible
                  ? _c(
                      "div",
                      { staticClass: "input-container" },
                      [
                        _c("w-input", {
                          staticClass: "password-field",
                          attrs: {
                            disabled: _vm.isSending,
                            password: "",
                            placeholder: _vm.$ct("type-password-to-unlock"),
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.submit()
                            },
                          },
                          model: {
                            value: _vm.password,
                            callback: function ($$v) {
                              _vm.password = $$v
                            },
                            expression: "password",
                          },
                        }),
                        _c(
                          "w-button",
                          {
                            staticClass: "submit-button",
                            attrs: { disabled: _vm.isSending },
                            on: {
                              click: function ($event) {
                                return _vm.submit()
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "unlock-alt" } })],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
          _c(
            "app-error-message-box",
            {
              staticClass: "error-message-box",
              attrs: { hide: _vm.error == _vm.emptyErrorMessage },
            },
            [_vm._v(_vm._s(_vm.error))]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }